// Mock vide pour modules natifs non disponibles dans le navigateur
module.exports = {};
